window.Good = require('../src/goods.js');
window.Guarantor = require('../src/guarantors.js');
window.Manifesto = require('../src/manifestos.js');
window.Traderdec = require('../src/traderdecs.js');
window.Uetd = require('../src/uetds.js');
window.GvmsManifesto = require('../src/gvms_manifesto.js');